/*
 * Ubezpieczenie Paczki — switch dodający/usuwający podlinkowany wariant produktu w koszyku.
 * - ON  -> /cart/add.js (qty 1)
 * - OFF -> /cart/change.js (qty 0)
 * Po zmianie odświeża zawartość <cart-drawer> przez Section Rendering API (bez zamykania drawera).
 * Stan domyślny ON: auto-dodaje raz na sesję, dopóki user sam nie wyłączy (sessionStorage).
 */
(function () {
  if (window.customElements.get('shipping-insurance')) return;

  var SS_KEY = 'osInsuranceDismissed';

  function sectionIdOf(el) {
    var sec = el.closest('.shopify-section');
    if (sec && sec.id) return sec.id.replace('shopify-section-', '');
    return 'cart-drawer';
  }

  function dismissed() { try { return sessionStorage.getItem(SS_KEY) === '1'; } catch (e) { return false; } }
  function setDismissed(v) {
    try { v ? sessionStorage.setItem(SS_KEY, '1') : sessionStorage.removeItem(SS_KEY); } catch (e) { /* noop */ }
  }

  // Świadomy opt-in (dla trybu default-OFF): zapamiętujemy, że to USER sam włączył ubezpieczenie,
  // żeby NIE usuwać go przy reloadzie/odświeżeniu drawera. Brak flagi + w koszyku = pozostałość -> usuń.
  var OPT_KEY = 'osInsuranceOptedIn';
  function optedIn() { try { return sessionStorage.getItem(OPT_KEY) === '1'; } catch (e) { return false; } }
  function setOptedIn(v) { try { v ? sessionStorage.setItem(OPT_KEY, '1') : sessionStorage.removeItem(OPT_KEY); } catch (e) { /* noop */ } }

  // Podmienia tylko wnętrze <cart-drawer> (zachowuje sam element i jego stan otwarcia).
  function refreshDrawer(html) {
    if (!html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector('cart-drawer');
    var current = document.querySelector('cart-drawer');
    if (fresh && current) {
      current.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
      current.innerHTML = fresh.innerHTML;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  class ShippingInsurance extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.variantId = this.dataset.variantId;
      this.input = this.querySelector('.os-ins__input');
      this.inCart = this.dataset.inCart === 'true';
      this.otherItems = parseInt(this.dataset.otherItems || '0', 10) || 0;
      this.defaultOn = this.dataset.defaultState === 'on';

      if (this.input) {
        this.input.addEventListener('change', this.onToggle.bind(this));
      }

      // Ubezpieczenie zostało samo w koszyku (brak realnych produktów) -> usuń je.
      if (this.inCart && this.otherItems <= 0) {
        this.setQuantity(0, false);
        return;
      }

      if (this.defaultOn) {
        // Domyślnie włączone: dodaj raz, jeśli są produkty, nie ma jeszcze ubezpieczenia i user go nie wyłączył.
        if (!this.inCart && this.otherItems > 0 && !dismissed()) {
          this.setQuantity(1, false);
        }
      } else {
        // Domyślnie WYŁĄCZONE (opt-in): jeśli ubezpieczenie jest w koszyku, a user sam go NIE włączył w tej sesji
        // (pozostałość z okresu gdy default był ON / stary koszyk) -> usuń, by start był ZAWSZE "off".
        if (this.inCart && this.otherItems > 0 && !optedIn()) {
          this.setQuantity(0, false);
        }
      }
    }

    onToggle() {
      var on = this.input.checked;
      setDismissed(!on); // ręczne wyłączenie = nie dodawaj ponownie w tej sesji (dla default-ON)
      setOptedIn(on);    // świadomy opt-in (dla default-OFF: nie usuwaj przy reloadzie/odświeżeniu)
      this.setQuantity(on ? 1 : 0, true);
    }

    busy(b) {
      this.classList.toggle('os-ins--busy', b);
      if (this.input) this.input.disabled = b;
    }

    setQuantity(qty, fromUser) {
      var self = this;
      this.busy(true);
      var sectionId = sectionIdOf(this);
      var url, payload;
      if (qty > 0) {
        url = '/cart/add.js';
        payload = { items: [{ id: this.variantId, quantity: 1 }], sections: sectionId, sections_url: window.location.pathname };
      } else {
        url = '/cart/change.js';
        payload = { id: String(this.variantId), quantity: 0, sections: sectionId, sections_url: window.location.pathname };
      }

      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data && data.sections && data.sections[sectionId];
          if (html) { refreshDrawer(html); return; }
          // fallback: pobierz sekcję osobno
          return fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionId))
            .then(function (r) { return r.json(); })
            .then(function (j) { refreshDrawer(j && j[sectionId]); });
        })
        .catch(function () {
          // przywróć wizualny stan switcha przy błędzie
          if (fromUser && self.input) self.input.checked = !(qty > 0);
          self.busy(false);
        });
    }
  }

  window.customElements.define('shipping-insurance', ShippingInsurance);
})();
